import React, { useContext, useEffect, useRef } from 'react'
import { styled } from 'linaria/react'
import UseFormatProduct from '../Hooks/UseFormatProduct'
import { theme } from '../../Theme'
import WhishlistButton from '../Buttons/WishlistButton'
import ChannelContext from '@jetshop/core/components/ChannelContext/ChannelContext'
import {
   getShippingEstimateMessage,
   getStickersFromProductSettings,
   stripQueryParamFromUrl,
} from '../Util/Helpers'
import Image from '@jetshop/ui/Image/Image'
import { useIntl } from '@jetshop/intl'
import Link from '../Link'
import { useAddToCart } from '../../../hooks/useAddToCart'
import { css } from 'linaria'
import StarIconScalable from '../Icons/StarIconScalable'
import { TEST_FREAK_RATING_THRESHOLD } from '../Util/Constants'
import PriceSectionWithLabel from './PriceSectionWithLabel'
import { Above } from '@jetshop/ui/Breakpoints'
import useScaleFontSizeToParent from '../../../hooks/useScaleFontSizeToParent'
// import { ReactComponent as PrebookIcon } from '../../../svg/Prebook.svg'
// import { ReactComponent as OutOfStockIcon } from '../../../svg/OutOfStock.svg'
// import { ReactComponent as InStockIcon } from '../../../svg/InStock.svg'


export const primaryShadow = css`
   -webkit-box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
   -moz-box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
   box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
`

const ProductCardContainer = styled.div`
   a {
      font-family: var(--font-grotesk);
      color: white;
      text-decoration: none;
   }

   &.product-card {
      /* -webkit-box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
      -moz-box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
      box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08); */
      background: ${theme.colors.white};
      overflow: hidden;
      /* box-shadow: none; */
      scale: 1;
      transition: all 0.5s ease;
      width: 100%;
   }

   &.product-card:hover {
      transition: box-shadow 0.5s, scale 0.3s ease;
      box-shadow: 0 0 0 6px rgba(25, 81, 120, 0.2);
      scale: 1.005;
   }

   .card-top-content {
      padding-top: 0.5rem;
   }

   .product-card-image [data-flight-image-placeholder] img,
   .product-card-image [data-flight-image] img {
      margin-top: 0.5rem;
      padding: 1rem;
   }

   .product-card-logos {
      width: 100%;
      position: absolute;
      bottom: 0;
   }

   .product-card-wishlist {
      position: absolute;
      top: 0;
      right: 0;
   }

   .rating-container {
      min-height: 1.1rem;
      display: flex;
      align-items: flex-start;
   }

   .product-card-sku {
      font-size: 0.75rem;
      font-family: var(--font-industry);
   }

   .product-card-stock-container {
      span {
         font-family: var(--font-grotesk);
         font-size: 0.75rem;
         font-weight: 700;
         svg {
            width: 24px;
            height: 24px;
         }
      }
   }

   .product-card-title {
      font-size: 1rem;
      font-weight: 700;
   }

   .product-card-title a {
      font-family: var(--font-industry);
      color: black;
   }

   .product-card-cta {
      font-family: var(--font-industry);
      font-weight: 700;
      text-transform: uppercase;
      color: white;
      text-align: center;
      background-color: #59a021;
      transition: all 0.3s ease;
      line-height: 1;

      ${theme.below.md} {
         font-size: 0.9375rem;
      }
   }

   .product-card-cta:hover {
      background-color: #4f8e1c;
      transition: all 0.3s ease;
   }

   .heart-animation {
      //background-image: url('../images/sprite/heart-sprite.svg');
      background-repeat: no-repeat;
      background-size: 2900%;
      background-position: left;
      height: 80px;
      width: 80px;
      margin-right: -19px;
      margin-top: -19px;
      cursor: pointer;
      right: 0;
   }

   .product-card-cta-prebook {
      color: var(--color-black);
      background-color: var(--color-prebook);
      transition: all 0.3s ease;
   }

   .product-card-cta-prebook:hover {
      background-color: var(--color-prebook-hover);
      transition: all 0.3s ease;
   }

   .product-card-cta-outofstock,
   .product-card-cta-store-only {
      color: var(--color-black);
      background-color: var(--color-outofstock);
      transition: all 0.3s ease;
      pointer-events: none;
   }

   .product-card-cta-outofstock:hover,
   .product-card-cta-store-only:hover {
      background-color: var(--color-outofstock-hover);
      transition: all 0.3s ease;
   }

   .product-card-cta-default {
      color: var(--color-white);
      background-color: var(--color-vb-blue);
      transition: all 0.3s ease;
   }

   .product-card-cta-default:hover {
      background-color: var(--color-vb-blue-darker);
      transition: all 0.3s ease;
   }

   .animate-heart {
      animation: heart-burst 0.8s steps(28) forwards;
   }
   @keyframes heart-burst {
      0% {
         background-position: left;
      }
      100% {
         background-position: right;
      }
   }

   .sticker-max {
      ${theme.below.md} {
         min-width: 25px;
         max-width: 100%;
      }
   }

   .shipping-estimate-message {
      font-weight: 400 !important;
      font-family: var(--font-industry) !important;
   }
`

const ProductListCard = ({ product, productSettings, closeModal }) => {
   const { selectedChannel } = useContext(ChannelContext)
   let {
      title,
      brandName,
      articleNumber,
      imageUrl,
      imageSmallUrl,
      url,
      isPreBook,
      buyable,
      hasVariants,
      onSale,
      isNew,
      isPackage,
      onlyForSaleInStore,
      testFreakRating,
   } = UseFormatProduct(product)
   const t = useIntl()
   const { addProductToCart } = useAddToCart()

   // Secure that shipping message is always visible
   const shippingEstimateMessageRef = useRef(null);
   useScaleFontSizeToParent(shippingEstimateMessageRef);
   
   const isPreBookValue = isPreBook
   const buyableValue = isPreBook ? true : (onlyForSaleInStore ? false : buyable)

   let strippedUrl = stripQueryParamFromUrl(url ?? '', 'att')

   // Only show shipping estimate message for Sweden
   const showShippingEstimateMessage = buyableValue && !isPreBookValue && selectedChannel?.id === 1
   const shippingEstimateMessage = showShippingEstimateMessage ? getShippingEstimateMessage(selectedChannel?.id, false) : ''

   const {
      campaignSticker,
      newSticker,
      packageSticker,
      preBookCampaignSticker,
   } = getStickersFromProductSettings(productSettings)

   const showTestFreakRating = typeof testFreakRating === 'number' && testFreakRating >= TEST_FREAK_RATING_THRESHOLD;

   const addToCart = e => {
      if (!buyableValue) {
         return
      }
      e.preventDefault()
      if (!buyableValue) {
         return
      }
      addProductToCart(product, articleNumber, 1, isPackage)
   }

   const titleWithPossibleBrandName = (
      <Link
         to={strippedUrl}
         className="line-clamp-3"
         onNavigation={() => closeModal && closeModal()}
      >
         {title && brandName ? `${brandName} ${title}` : title}
      </Link>
   )

   return (
      <ProductCardContainer className="product-card primary-shadow br-8 d-flex flex-column">
         <div className="position-relative">
            <Link
               to={strippedUrl}
               onNavigation={() => closeModal && closeModal()}
            >
               <Above breakpoint="sm">
                  {matches => (
                     <Image
                        className="product-card-image p-16"
                        src={matches ? imageUrl : imageSmallUrl}
                        alt={title}
                        aspect="1:1"
                     ></Image>
                  )}
               </Above>
            </Link>
            <div className="row m-0 d-flex align-items-start product-card-wishlist pe-none">
               <div className="col-12 d-flex justify-content-end p-0">
                  <div className="pe-auto">
                     <WhishlistButton
                        articleNumber={articleNumber}
                        title={title}
                     ></WhishlistButton>
                  </div>
               </div>
            </div>
            <div className="row m-0 d-flex align-items-end product-card-logos pb-2">
               <div className="d-flex justify-content-start flex-wrap">
                  {campaignSticker && onSale && isPreBookValue && (
                     <img
                        className="img-fluid sticker-max"
                        alt="Campaign sticker"
                        src={preBookCampaignSticker}
                     />
                  )}
                  <div className="d-flex justify-content-start col-md-5">
                     {campaignSticker && onSale && !isPreBookValue && (
                        <img
                           className="img-fluid sticker-max"
                           alt="Campaign sticker"
                           src={campaignSticker}
                        />
                     )}
                     {newSticker && isNew && (
                        <img
                           className="img-fluid sticker-max"
                           alt="New sticker"
                           src={newSticker}
                        />
                     )}
                     {packageSticker && isPackage && (
                        <img
                           className="img-fluid sticker-max"
                           alt="Package sticker"
                           src={packageSticker}
                        />
                     )}
                  </div>
               </div>
               <div className="col-6 d-flex justify-content-end pr-32"></div>
            </div>
         </div>
         <div className="product-card-description d-flex flex-column flex-grow-1 pr-16 pl-16 pb-16 pt-0">
            <div className="rating-container">
               {showTestFreakRating && (
                  <>
                     <StarIconScalable
                        filled={
                           isNaN(testFreakRating / 5) ? 1 : testFreakRating / 5
                        }
                     ></StarIconScalable>
                  </>
               )}
            </div>
            <div className="product-card-sku">ARTNR: {articleNumber}</div>
            <div className="product-card-title lh-1 pb-8 pt-1 d-flex flex-grow-1">
               {titleWithPossibleBrandName}
            </div>
            <div className="row d-flex align-items-center">
               <div
                  className="d-flex flex-column"
                  style={{
                     fontSize: '11px',
                     lineHeight: '1em',
                     fontWeight: 'bold',
                  }}
               ></div>
               <PriceSectionWithLabel
                  label={hasVariants ? t('from') : ''}
                  product={product}
                  selectedChannel={selectedChannel}
               ></PriceSectionWithLabel>
               <span
                  ref={shippingEstimateMessageRef}
                  className="shipping-estimate-message line-clamp-1"
               >
                  {shippingEstimateMessage}
               </span>
               {/* <div className="col-12 d-flex product-card-stock-container">
                  <span className="d-flex align-items-center">
                     {isPreBookValue ? (
                        <>
                           <PrebookIcon className="pr-8"></PrebookIcon>
                           {t('book in advance')}
                        </>
                     ) : buyable ? (
                        <>
                           <InStockIcon className="pr-8"></InStockIcon>
                           {t('in stock')}
                        </>
                     ) : (
                        <>
                           <OutOfStockIcon className="pr-8"></OutOfStockIcon>
                           {t('Out of stock')}
                        </>
                     )}
                  </span>
               </div> */}
               {/* <div className="col-12 d-flex">
                  <span className="product-card-stock d-flex align-items-center">
                     <Title size="0.75rem" weight={700}>
                        4 av 5 (100st)
                     </Title>
                  </span>
               </div> */}
            </div>
         </div>
         {hasVariants ? (
            <Link
               className="product-card-cta-link"
               to={strippedUrl}
               onNavigation={() => closeModal && closeModal()}
            >
               <div className="product-card-cta py-16 px-8">
                  {t('see variants')}
               </div>
            </Link>
         ) : (
            <Link
               className="product-card-cta-link"
               to={strippedUrl}
               onClick={onlyForSaleInStore ? (e) => e.preventDefault() : addToCart}
            >
               <div
                  className={`product-card-cta ${
                     onlyForSaleInStore
                        ? 'product-card-cta-store-only'
                        : isPreBookValue
                        ? 'product-card-cta-prebook'
                        : buyableValue
                        ? ''
                        : 'product-card-cta-outofstock'
                  } py-16 px-8`}
               >
                  {onlyForSaleInStore
                     ? t('only for sale in store')
                     : isPreBookValue
                     ? t('book in advance')
                     : buyableValue
                     ? t('add to cart')
                     : t('Out of stock')}
               </div>
            </Link>
         )}
      </ProductCardContainer>
   )
}

export default ProductListCard